import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-audio-player-volume';
export var ID = 'icon-audio-player-volume';
/* eslint-disable max-len */

export var SVGAudioPlayerVolume = function SVGAudioPlayerVolume() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 23 20"
  }, React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.754 0v20L5.36 14.342 0 13.871V6.129l5.36-.471L12.754 0zm3.574 3.524A9.585 9.585 0 0 1 18.834 10a9.585 9.585 0 0 1-2.506 6.476l-1.663-1.513c1.191-1.29 1.91-3.052 1.91-4.963 0-1.91-.719-3.648-1.91-4.963l1.663-1.513zM19.107.993A13.354 13.354 0 0 1 22.58 10c0 3.474-1.315 6.625-3.474 9.007l-1.663-1.513A11.076 11.076 0 0 0 20.347 10c0-2.878-1.116-5.509-2.903-7.494L19.107.993z"
  }));
};
/* eslint-disable max-len */

var AudioPlayerVolume = function AudioPlayerVolume(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGAudioPlayerVolume
  });
};

AudioPlayerVolume.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default AudioPlayerVolume;